import { useForm } from "react-hook-form";
import { JVDropdown } from "../../shared/JVDropdown";
import { Button } from "primereact/button";
import * as yup from "yup";
import { JVDate } from "../../shared/JVDate";
import { useEffect, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { IBranchMastDropdown, ICompanyMastDropdown, ISkillCategoriesDropdown, ITeamsDropdown, IUsersDropdown } from "../../models/IDropdown";
import { ILogin } from "../../models/Login";
import { JVInput } from "../../shared/JVInput";
import { string } from "yup/lib/locale";
import { yupResolver } from "@hookform/resolvers/yup";


export interface ISalesAllocationFilter {
    fromDate?: Date | null,
    toDate?: Date | null
    req_PostedBySalesManager?: number | null,
    vendor_Company_Name?: string | null,
    req_Category?: number | null
    req_ID?: number | null | string,
    converted?: boolean | null,
    Company?: number | null,
    Branch?: number | null,
    Team_Name?: number | null,
    SM?: number | null,
}

export const EmptyFilter: ISalesAllocationFilter = {
    fromDate: new Date,
    toDate: new Date,
    req_PostedBySalesManager: null,
    vendor_Company_Name: "",
    req_Category: null,
    req_ID: "",
    Company: null,
    Branch: null,
    Team_Name: null,
    SM: null,
    converted: null,
}

const schema = yup.object({
    fromDate: yup.date().nullable(),
    toDate: yup.date().nullable(),
    vendor_Company_Name: yup.string().nullable(),
    req_ID: yup.string().nullable(),
    req_Category: yup.string().nullable(),
    Company: yup.string().nullable(),
    Branch: yup.string().nullable(),
    Team_Name: yup.number().nullable(),
    SM: yup.number().nullable(),
    converted: yup.string().nullable(),

});
export interface IProps {
    filters: ISalesAllocationFilter,
    setFilters: (filters: ISalesAllocationFilter) => void,
    loading: boolean
}

export const Filter = (props: IProps) => {
    const [skillCategories, setSkillCategories] = useState<Array<ISkillCategoriesDropdown>>();
    const [sm, setSM] = useState<Array<IUsersDropdown>>();
    const [company, setCompany] = useState<Array<ICompanyMastDropdown>>();

    const [team, setTeam] = useState<Array<ITeamsDropdown>>();
    const [branch, setBranch] = useState<Array<IBranchMastDropdown>>();

    const { control, handleSubmit, formState: { errors }, reset, watch, setValue } = useForm<ISalesAllocationFilter>({
        shouldFocusError: false, resolver: yupResolver(schema),
        defaultValues: props.filters,

    });

    const convertedValues = [
        { label: "YES", value: true },
        { label: "NO", value: false },
    ]


    const _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach(role => {
        _roles.push(role.role_ID);
    });

    const loadSkillCategories = async () => {
        const response = await Fetch("Dropdown/skillsCategories", "GET", null, null, null);
        if (response) {
            const data: Array<ISkillCategoriesDropdown> = await response.json();
            const emptyData = {
                req_CategoryID: 0,
                req_CategoryName: "-- SELECT --",
            };
            data.unshift(emptyData);
            setSkillCategories(data);
        }
    }

    const loadSm = async (branch: number | null | undefined, company: number | null | undefined, team: number | null | undefined) => {
        let queryParameter = null;
        if (team != 0 && team != null) {
            queryParameter = `team_ID=${team}`;
        } else if (branch != 0 && branch != null) {
            queryParameter = `branch_ID=${branch}`;
        } else if (company != 0 && company != null) {
            queryParameter = `company_ID=${company}`;
        }

        const response = await Fetch("Dropdown/filterUsersList", "GET", null, queryParameter, null);
        if (response) {
            const data: Array<IUsersDropdown> = await response.json();
            const emptyData = {
                login_ID: 0,
                user_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setSM(data);
        }
    }
    const loadTeam = async (branch: number | null | undefined, company: number | null | undefined, type?: string) => {
        let queryParameter = null;
        if (branch != 0 && branch != null) {
            queryParameter = `branch_ID=${branch}`;
        } else if (company != 0 && company != null) {
            queryParameter = `company_ID=${company}`;
        }

        if (type && type != "" && type != "-- SELECT --") {
            if (type === "sales") queryParameter = "user_Type=sales&" + queryParameter;
            if (type === "recruiter") queryParameter = "user_Type=recruiter&" + queryParameter;
        }

        const response = await Fetch("Dropdown/filterTeamsList", "GET", null, queryParameter, null);
        if (response) {
            const data: Array<ITeamsDropdown> = await response.json();
            const emptyData = {
                team_ID: 0,
                team_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setTeam(data);
        }
    }

    const loadBranch = async (company?: number | null | undefined) => {
        let queryParam = company ? `company_id=${company}` : null;
        const response = await Fetch("Dropdown/filterBranchList", "GET", null, queryParam, null);
        if (response) {
            const data: Array<IBranchMastDropdown> = await response.json();
            const emptyData = {
                branch_ID: 0,
                branchName: "-- SELECT --",
                company_ID: 0
            };
            data.unshift(emptyData);
            setBranch(data);
        }
    }
    const loadCompany = async () => {
        const response = await Fetch("Dropdown/reqCompanyList", "GET", null, null, null);
        if (response) {
            const data: Array<ICompanyMastDropdown> = await response.json();
            const emptyData = {
                company_ID: 0,
                company_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setCompany(data);
        }
    }
    useEffect(() => {
        const subscription = watch((value, { name, type }) => {
            if (name === "Company") {
                if (value.Company != 0 && value.Company != null) {
                    loadTeam(0, value.Company);
                    loadSm(0, value.Company, 0);
                    loadBranch(value.Company);
                } else {
                    if (value.Company === 0 && value.Company != null) {
                        loadBranch();
                        loadTeam(control._formValues.Branch, value.Company);
                        loadSm(control._formValues.Branch, value.Company, control._formValues.Team_Name);
                    }
                }
            }
            if (name === "Branch") {
                if (value.Branch != 0 && value.Branch != null) {
                    loadTeam(value.Branch, 0);
                    loadSm(value.Branch, 0, 0);

                } else {
                    if (value.Branch === 0 && value.Branch != null) {
                        loadTeam(value.Branch, control._formValues.Company);
                        loadSm(value.Branch, control._formValues.Company, control._formValues.Team_Name);
                    }
                }
            }

            if (name === "Team_Name") {
                if (value.Team_Name != 0 && value.Team_Name != null) {
                    loadSm(0, 0, value.Team_Name);

                } else {
                    if (value.Team_Name === 0 && value.Team_Name != null) {

                        loadSm(control._formValues.Branch, control._formValues.Company, value.Team_Name);
                    }
                }
            }
        });

        return () => subscription.unsubscribe();
    }, [watch]);

    useEffect(() => {
        loadSkillCategories();
        loadSm(0, 0, 0);
        loadTeam(0, 0);
        loadBranch();
        loadCompany();
    }, []);

    const searchToDB = async (body: ISalesAllocationFilter) => {
        if (body.req_ID) body.req_ID = body.req_ID === "" ? 0 : (typeof (body.req_ID) === "string" ? Number(body.req_ID.trim()) : body.req_ID);
        props.setFilters(body);
    }
    const onSubmit = (data: ISalesAllocationFilter) => {
        searchToDB(data);
    }

    const onClear = () => {
        reset(EmptyFilter)
        loadSm(0, 0, 0);
        loadTeam(0, 0, "");
        loadBranch();
        loadCompany();
    }
    return (
        <>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                <JVDate maxDate={new Date} column={6} label="From Date" control={control} name="fromDate" />
                <JVDate maxDate={new Date} column={6} label="To Date" control={control} name="toDate" />
                <JVInput column={6} label="Vendor Company Name" control={control} name="vendor_Company_Name" />
                <JVInput column={6} label="Req ID" type="number" control={control} name="req_ID" />
                <JVDropdown column={6} label="Req Category" control={control} name="req_Category" options={skillCategories} optionLabel="req_CategoryName" optionValue="req_CategoryID" placeholder="Select Req Category" />
                <JVDropdown column={6} label="Company Name " control={control} name="Company" options={company} optionLabel="company_Name" optionValue="company_ID" placeholder="Select Company Name" />
                <JVDropdown column={6} label="Branch " control={control} name="Branch" options={branch} optionLabel="branchName" optionValue="branch_ID" placeholder="Select Branch " />
                <JVDropdown column={6} label="Team Name" control={control} name="Team_Name" options={team} optionLabel="team_Name" optionValue="team_ID" placeholder="Select Team Name" />
                <JVDropdown column={6} label="S M" control={control} name="SM" options={sm} optionLabel="user_Name" optionValue="login_ID" placeholder="SM" />
                <JVDropdown column={6} label="Converted" control={control} name="converted" options={convertedValues} optionLabel="label" optionValue="value" placeholder="Select" />
                <div style={{ margin: '10px 0', width: '100%' }}></div>
                <div className="col-12 md:col-12" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: '10px', marginTop: '10px' }}>
                    <Button className="field col-12 md:col-6" label="SEARCH" type="submit"></Button>
                    <Button className="field col-12 md:col-6 p-button-outlined" label="CLEAR" onClick={onClear} type="button"></Button>
                </div>
            </form>
        </>
    )
}